import PrivateDriverHirePage from "@/pages/PrivateDriverHire/PrivateDriverHire";
export default function DayTripsPage() {
  return <PrivateDriverHirePage />;
}